/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainProposedBlocksRequest
 */
export interface ChainProposedBlocksRequest {
    /**
     * 
     * @type {string}
     * @memberof ChainProposedBlocksRequest
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksRequest
     */
    size: number;
}

export function ChainProposedBlocksRequestFromJSON(json: any): ChainProposedBlocksRequest {
    return ChainProposedBlocksRequestFromJSONTyped(json, false);
}

export function ChainProposedBlocksRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainProposedBlocksRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function ChainProposedBlocksRequestToJSON(value?: ChainProposedBlocksRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'page': value.page,
        'size': value.size,
    };
}


